import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaTooltip'

type IcaTooltipProps = React.JSX.IntrinsicElements['tgdb-ica-tooltip']

export const IcaTooltip = wrapWc<IcaTooltipProps>('tgdb-ica-tooltip', [])
